"use client";
import { Button } from "react-bootstrap";
import { baseUrl } from "utils/constants";

export default function BlankPage() {
  return (
	
		<div>
			<div className="cpr_content">
				<div className="cpr_content_inner">
						<div className="cpr_content_bottom">
							{/* placeholder for middle content */}
							{/* chat bubbles and cards */}
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
									Find Homes by Community
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								Sunrise Pines - HOUSTON homes for sale and rent. Find details, real estate for sale, real estate for rent and more near Sunrise Pines - HOUSTON.
								</div>
							</div>

							<div className="cardv2 rccrd_neghbothood left_margin d-flex p-2">
								<div className="rccrd_neghbothood__map" style={{
    								backgroundImage:'url("https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/path-2+0000ff-0.45+0000ff-0.45(ghzuDxx%7BeQvBvHbN_J%60ClGm%40t%5DvGuDvD%7DA%7CGyD%7CBw%40bAo%40eLuVjG%3FrCiD%3FkFgH%3FkAcDwHHq%40eB%7DNJQbHaB%7EEyD%7CDoAv%40)/auto/156x191?access_token=pk.eyJ1IjoiaGFyZGV2ZXJpY2siLCJhIjoiY2w5Y3h1aGdxMXRrZzNwbDltMXAwMjlwZyJ9.WvBLDoZQnZlozgGqlCij-A")'
													}}>
								</div>
								<div className="rccrd_neghbothood__text align-self-center p-3">
									<h3 tabIndex={0}>Sunrise Pines</h3>
									<div className="cardv2--area__desc pb-2">
										464 Single Family Properties
										<br />
										$233K average price
									</div>
									<div className="cardv2--area__link mb-0">
										Houses in <br /> Sunrise Pines{" "}
									</div>
								</div>
							</div>

							
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
									show me Elementary School in Katy Texas area
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								Black Elementary School is located at 14155 GRANT RD, CYPRESS, TX, 77429. The school is part of CYPRESS-FAIRBANKS ISD.
								</div>
							</div>

							<div className="cardv2 rccrd_neghbothood left_margin d-flex p-2">
								<div className="rccrd_neghbothood__map" style={{
    								backgroundImage:'url("https://www.har.com/api/staticmap?sensor=false&zoom=15&size=270x190&center=30.005000000000000,-95.637800000000000&markers=icon:https://www.har.com/img/icons/pin_general.png%7C30.005000000000000,-95.637800000000000&client=gme-houstonrealtorsinformation&token=school")'
													}}>
								</div>
								<div className="rccrd_neghbothood__text align-self-center p-4">
								
									<h4 tabIndex={0} className="color_carbon mb-0">
										Black Elementary School
									</h4>
									<div className="font_size--small color_auxiliary pb-2">Grade Span: PK-05</div>
									<div className="pb-3">
										<img
										alt="rating star"
										className="pb-1"
										src="https://content.harstatic.com/media/icons/stars_16by16_yellow.svg"
										width={16}
										height="auto"
										style={{ width: 16 }}
										/>
										<img
										alt="rating star"
										className="pb-1"
										src="https://content.harstatic.com/media/icons/stars_16by16_yellow.svg"
										width={16}
										height="auto"
										style={{ width: 16 }}
										/>
										<img
										alt="rating star"
										className="pb-1"
										src="https://content.harstatic.com/media/icons/stars_16by16_yellow.svg"
										width={16}
										height="auto"
										style={{ width: 16 }}
										/>
										<img
										alt="rating star"
										className="pb-1"
										src="https://content.harstatic.com/media/icons/stars_16by16_yellow.svg"
										width={16}
										height="auto"
										style={{ width: 16 }}
										/>
										<img
										alt="rating star"
										className="pb-1"
										src="https://content.harstatic.com/media/icons/stars_16by16_yellow.svg"
										width={16}
										height="auto"
										style={{ width: 16 }}
										/>
									</div>
									<div className="label label--grade label--grade_a">A</div>
									<span className="font_size--medium color_auxiliary">Excellent</span>
									<div className="pt-3">
										<img
										alt="Medal"
										src="https://content.harstatic.com/media/icons/school-grade-medal.svg"
										title=""
										data-toggle="tooltip"
										data-placement="top"
										data-original-title="Progress Distinction"
										/>
										<img
										alt="Medal"
										src="https://content.harstatic.com/media/icons/school-grade-medal.svg"
										title=""
										data-toggle="tooltip"
										data-placement="top"
										data-original-title="GAP Distinction"
										/>
									</div>
									

								</div>
							</div>

							
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
									Show only open houses in Houston Texas area
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								15763 Tanya Cir, Houston, TX 77079
								</div>
							</div>

							<div className="cardv2 rccrd_neghbothood left_margin d-flex p-2">
								<div className="rccrd_neghbothood__map" style={{
    								backgroundImage:'url("https://content.harstatic.com/media/harlive/open-house.svg")',backgroundPosition:'center'
													}}>
								</div>
								<div className="rccrd_neghbothood__text align-self-center p-4">
									<div className="pl-3" style={{ borderLeft: "2px solid #fd4b78" }}>
										<div className="color_carbon text-left font_weight--semi_bold font_size--large_extra">
											Tuesday, Sep 17, 2024
											<div>
											<a
												className="font_weight--semi_bold color_sold font_size--small"
												href="https://www.har.com/search/OpenHouseDetail/14164953/53691829?vcard=1"
												style={{ verticalAlign: "middle" }}
											>
												Add to Calendar
											</a>
											</div>
										</div>
										<div className="color_slate_light text-left font_weight--semi_bold mt-1 mb-2">
											03:00 PM - 04:00 PM
										</div>
										<div className="row no-gutters pb-1 pt-1">
											<div className="col-auto pr-3">
											<a
												className="font_weight--semi_bold color_sold mt-2"
												href="https://www.har.com/search/OpenHouseDetail/14164953/53691829"
											>
												See More
											</a>
											</div>
											<div className="col-auto justify-content-md-center pl-md-2">
											<a
												className="font_weight--semi_bold color_sold mt-2"
											>
												Share
											</a>
											</div>
										</div>
										</div>

									

								</div>
							</div>


							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
									Show only open houses in Houston Texas area
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								15763 Tanya Cir, Houston, TX 77079
								</div>
							</div>

							<div className="cardv2 rccrd_neghbothood left_margin d-flex p-2">
								<div className="rccrd_neghbothood__map bg_color_auxiliary d-flex align-items-center justify-content-center" style={{minWidth:'120px'}}>
									<svg width="80" height="80" viewBox="0 0 135 135" xmlns="http://www.w3.org/2000/svg">
										<g fill="none" fillRule="evenodd">
											<circle stroke="#FFFFFF" strokeWidth="8" cx="67.5" cy="67.5" r="63.5"/>
											<g stroke="#FFFFFF">
												<path strokeWidth="7.25" strokeLinecap="round" strokeLinejoin="round" d="M96.5 57.62v43.5h-58v-43.5"/>
												<path d="M78.375 76.91c0 4.76-2.541 7.506-7.623 8.238v5.097h-4.356v-4.92c-3.106-.147-5.486-.946-7.14-2.396-1.653-1.45-2.48-3.866-2.48-7.25v-2.13h7.533v2.658c0 2.929 1.028 4.394 3.085 4.394 1.09 0 1.876-.26 2.36-.78s.726-1.403.726-2.648c0-2.197-1.392-4.232-4.175-6.107-.08-.059-.73-.484-1.951-1.274-1.22-.791-1.931-1.26-2.133-1.406-3.73-2.476-5.596-5.383-5.596-8.722 0-5.083 3.166-7.77 9.499-8.063v-4.856h4.356v5.053c1.976.323 3.529.982 4.658 1.978 1.634 1.45 2.45 3.859 2.45 7.228v1.933H70.42v-2.175c0-1.494-.232-2.603-.696-3.328-.463-.725-1.235-1.088-2.314-1.088s-1.875.227-2.39.681c-.514.454-.77 1.23-.77 2.329 0 1.743 1.068 3.361 3.206 4.855l4.295 2.834c4.417 2.988 6.625 6.276 6.625 9.865z" strokeWidth="2.719" fill="#FFFFFF" fillRule="nonzero"/>
												<path d="M31.25 64.87 67.5 28.62l36.25 36.25" strokeLinecap="round" strokeLinejoin="round" strokeWidth="7.25"/>
											</g>
										</g>
									</svg>
								</div>
								<div className="rccrd_neghbothood__text align-self-center p-4">
									<div className=" font_size--large">This property may be eligible for 16 programs and up to $28,975 in down payment assistance.</div>
								</div>
							</div>


							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								Can you show me Agents in Pesadena Texas area ?
								</div>
							</div>

							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								Contact Jenna Clements a Texas Realtor servicing the Houston and Gulf Coast area. She is knowledgeable in the competitive markets of Galveston, Harris, Brazoria, and Wharton county where she was born and raised.
								</div>
							</div>

							<div className="richcontent_bubble left_margin ">
								{/* card--mini v2 */}
								<div className="cardv2--mini cursor--pointer " style={{maxWidth:'370px'}}>
									<div className="cardv2--mini__content">
									<div className="cardv2--mini__content__body">
										<a href="https://www.har.com/homedetail/120-carnarvon-dr-houston-tx-77024/3144594">
										{/* card img */}
										<div className="cardv2--mini__content__body__image">
											<div
											className="cardv2--mini__content__body__image__img bg__bottom"
											style={{
												backgroundImage:
												"url(https://photos.harstatic.com/297961427/hr/img-1.jpeg?ts=2024-09-04T16:49:07.777)"
											}}
											/>
										</div>
										{/* / card img */}
										</a>
										{/* card header */}
										{/* card details */}
										<div className="cardv2--mini__content__body__details">
										<div>
											<div className="cardv2--mini__content__body__details_address">
											<div className="cardv2--mini__content__body__details_address_left">
												<div className="cardv2--mini__content__body__details_price">
												$425,000
												</div>
											</div>
											<div className="cardv2--mini__content__body__details_address_right">
												<div className="label label--forsale">Active</div>
											</div>
											</div>
											<div className="">
											<div className="cardv2--mini__content__body__details_address_left_add">
												15763 Tanya Cir
												<br />
												Houston, TX 77079
											</div>
											<div className="cardv2--mini__content__body__details_features">
												<ul>
												<li>4 - 5 beds</li>
												<li>3 baths</li>
												<li>3,808 sqft</li>
												</ul>
											</div>
											<div className="cardv2--mini__content__body__details_dayson">
												<div className="circle_nimber">1</div> Days on HAR
											</div>
											</div>
										</div>
										</div>
										{/* / card details */}
									</div>
									{/* / card body */}
									</div>
									{/* / card content */}
								</div>
								{/* / card--mini v2 */}
							</div>
											
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								How many bedrooms does the property have?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The property has 4 bedrooms, with a potential for a 5th bedroom in the flex room.
								</div>
							</div>
							
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								How many bathrooms are in the property?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The property has 3 full bathrooms and 1 half bathroom.
								</div>
							</div>
							{/*						
							<div className="user_bubble">
								<div className="user_bubble__img" style={{backgroundImage: 'url("https://pics.harstatic.com/agent/312961.jpg?ts=2020-03-01T19:56:00")' }} ></div>
								<div className="user_bubble__text">
								What is the square footage of the house?
								</div>
							</div>
						
							<div className="chatbot_bubble">
								<div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/common/HAR_AI_Logo.svg" /></div>
								<div className="chatbot_bubble__text">
								The house is 3,808 square feet.
								</div>
							</div>
							*/}

							{/* chat bubbles and cards ended */}
						</div>
				</div>
			</div>
			
			<div className="input_bar">
				

				<div className="input_main_container">
					<div className="input_text_bar">
						<input type="text" className="input_text_bar_text form-control" />
						<button type="button" className="btn btn--primary btn--large input_text_bar_btn d-flex align-items-center" disabled><img src="https://content.harstatic.com/media/icons/copilot/ai_node_arrow.svg" /></button>
					</div>
					<div className="footer_disclaimer font_size--small_extra color_auxiliary text-center pt-2 d-md-block d-none">
						HAR.AI may produce inaccurate information about listings, market, or facts. 
						<a className="color_auxiliary" href="#">HAR.AI Privacy Notice</a>
					</div>
					<div className="footer_disclaimer font_size--small_extra_extra color_auxiliary text-center pt-2 d-md-none d-block">
						HAR.AI may provide inaccurate details. Check <a className="color_auxiliary" href="#">HAR.AI Privacy Notice</a>
					</div>
				</div>
			</div>
		</div>
  );
}
